import "./App.css";
import Root from "./router/router";

function App() {
  return <Root />;
}

export default App;
